import { Box } from '@mui/material';
import { Skeleton } from './Skeleton';

export const FullPageSkeleton = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        padding: '24px',
        gap: '16px',
      }}
    >
      <Skeleton variant="rectangular" width="100%" height="60px" sx={{ maxWidth: '800px', borderRadius: '8px' }} />
      <Skeleton variant="rectangular" width="100%" height="400px" sx={{ maxWidth: '800px', borderRadius: '8px' }} />
    </Box>
  );
};
